import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NgxPermissionsService } from 'ngx-permissions';
import { AuthService } from './auth.service';
import { PermissionModel } from '../models/permission.model';
import { TokenModel } from '../models/token.model';

@Injectable({ providedIn: 'root' })
export class PermissionService {
  userPermissions: PermissionModel[] = [];

  constructor(
    private permissionsService: NgxPermissionsService,
    private authService: AuthService,
  ) {}

  loadPermissions() {
    const currentUser: TokenModel = new BehaviorSubject<TokenModel>(
      JSON.parse(localStorage.getItem('user')!),
    ).value as TokenModel;
    if (!this.authService.currentUser) {
      return;
    } else {
      this.userPermissions = this.authService.currentUser.permissions;
    }

    const Permissions = [];
    if (currentUser && this.userPermissions) {
      for (const permission of this.userPermissions) {
        Permissions.push(permission.name);
      }
    }
    this.permissionsService.loadPermissions(Permissions);
  }

  clearPermissions() {
    this.permissionsService.flushPermissions();
  }
}
